import { Tooltip, OverlayTrigger } from 'react-bootstrap'

const TOOLTIP_NAME_THRESHOLD = 18

const FormNameCell = ({ form }) => {
    const content = <span className="tw:max-w-[180px] tw:truncate">{form.name}</span>

    if (form.name.length <= TOOLTIP_NAME_THRESHOLD) {
        return content
    }

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id={`tooltip-${form.id}`} className="custom-tooltip table-tooltip">
                    {form.name}
                </Tooltip>
            }
        >
            {content}
        </OverlayTrigger>
    )
}

export default FormNameCell
